/*
 * @Author: Michael
 * @Date: 2018-01-05 11:08:10
 * @Last Modified by: wangxiang
 * @Last Modified time: 2021-08-28 15:56:31
 */
export default {
  routes: [
    {
      path: '/setting',
      name: 'mine_setting',
      component: () => import('@/module/mine/MineSetting.vue'),
      meta: {
        title: '设置',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine',
      name: 'mine',
      component: () => import('@/module/mine/MinePage.vue'),
      meta: {
        title: '我的',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/information',
      name: 'mine_information',
      component: () => import('@/module/mine/MineInformation.vue'),
      meta: {
        title: '个人信息',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/information/modify',
      name: 'mine_information_modify',
      component: () => import('@/module/mine/ModifyNamePage.vue'),
      meta: {
        title: '修改账户',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/information/relevance',
      name: 'mine_relevance',
      component: () => import('@/module/mine/Relevance.vue'),
      meta: {
        title: '关联学员',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points',
      name: 'mine_points',
      component: () => import('@/module/mine/PointSystem.vue'),
      meta: {
        title: '小麦粒',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/rule',
      name: 'mine_points_rule',
      component: () => import('@/module/mine/PointRule.vue'),
      meta: {
        title: '积分规则',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/redeem',
      name: 'mine_points_redeem',
      component: () => import('@/module/mine/PointsRedeem.vue'),
      meta: {
        keepAlive: false,
        logined: true,
        isUseCache: false,
      },
    },
    {
      path: '/mine/points/redeem/detail',
      name: 'mine_points_redeem_detail',
      component: () => import('@/module/mine/RedeemDetail.vue'),
      meta: {
        title: '礼品详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/detail',
      name: 'mine_points_detail',
      component: () => import('@/module/mine/PointsDetail.vue'),
      meta: {
        title: '积分明细',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/exchange_record',
      name: 'mine_points_exchange_record',
      component: () => import('@/module/mine/PointExchangeRecord.vue'),
      meta: {
        title: '兑换记录',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/exchange_record/detail',
      name: 'mine_points_exchange_record_detail',
      component: () => import('@/module/mine/PointExchangeRecordDetail.vue'),
      meta: {
        title: '兑换详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/points/rank_page',
      name: 'mine_points_rank_page',
      component: () => import('@/module/mine/RankPage.vue'),
      meta: {
        title: '排行榜',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/archives',
      name: 'mine_archives',
      component: () => import('@/module/mine/GrowthArthives.vue'),
      meta: {
        title: '我的收藏',
        keepAlive: true,
        logined: true,
      },
    },
    {
      path: '/mine/archives/detail',
      name: 'mine_archives_detail',
      component: () => import('@/module/mine/ArchivesDetailPage.vue'),
      meta: {
        title: '档案详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/archives/detail/comment',
      name: 'mine_archives_detail_comment',
      component: () => import('@/module/mine/ArchivesDetailCommentPage.vue'),
      meta: {
        title: '档案评论',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course',
      name: 'mine_course',
      component: () => import('@/module/mine/MineCourseHour/MineCoursePage.vue'),
      meta: {
        title: '课时查询',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course_v5',
      name: 'mine_course_v5',
      component: () => import('@/module/mine/MineCourseHour/MineCoursePageV5.vue'),
      meta: {
        title: '课时查询',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/face/collection',
      name: 'face_collection',
      component: () => import('@/module/mine/FaceCollection.vue'),
      meta: {
        title: '人脸录入',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/face/info',
      name: 'face_info',
      component: () => import('@/module/mine/FaceInfo.vue'),
      meta: {
        title: '人脸信息',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/website_privacy',
      name: 'website_privacy',
      component: () => import('@/module/mine/WebsitePrivacy.vue'),
      meta: {
        title: '小麦助教网站隐私协议',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course/detail',
      name: 'mine_course_detail',
      component: () => import('@/module/mine/MineCourseHour/MineCourseDetailPage.vue'),
      meta: {
        title: '点名记录',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course/v5detail',
      name: 'mine_course_detail_v5',
      component: () => import('@/module/mine/MineCourseHour/MineCourseDetailPageV5.vue'),
      meta: {
        title: '点名记录',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course/schedule/detail',
      name: 'mine_course_schedule_detail',
      component: () => import('@/module/mine/MineCourseScheduleDetailPage.vue'),
      meta: {
        title: '课次详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/mine/course/schedule/detail/v5',
      name: 'mine_course_schedule_detail_v5',
      component: () => import('@/module/mine/v5/MineCourseScheduleDetailPage.vue'),
      meta: {
        title: '课次详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/insurance/introduce',
      name: 'insurance_introduce',
      component: () => import('@/module/insurance/InsuranceIntroducePage.vue'),
      meta: {
        title: '保险介绍',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/notification',
      name: 'mine_institution_notification',
      component: () => import('@/module/mine/MineNotificationMessage.vue'),
      meta: {
        title: '机构通知',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/preview/picture',
      name: 'preview_picture',
      component: () => import('@/module/previewPicture/PreviewPicture.vue'),
      meta: {
        title: '礼品详情',
        keepAlive: false,
        logined: true,
      },
    },
    {
      path: '/remainder',
      name: 'remainder_page',
      component: () => import('@/module/mine/Remainder'),
      meta: {
        title: '余额',
        keepAlive: true,
        logined: true,
      },
    },
    {
      path: '/recharge/student',
      name: 'recharge_student',
      component: () => import('@/module/mine/RechargeStudent'),
      meta: {
        title: '充值账户关联学员',
        keepAlive: true,
        logined: true,
      },
    },
    {
      path: '/recharge/rule',
      name: 'recharge_rule',
      component: () => import('@/module/mine/RechargeRule'),
      meta: {
        title: '充值规则',
        keepAlive: true,
        logined: true,
      },
    },
    {
      path: '/mine/voucher',
      name: 'mine_voucher',
      component: () => import('@/module/mine/voucher/VoucherList.vue'),
      meta: {
        title: '我的订单',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/mine/contract',
      name: 'mine_contract',
      component: () => import('@/module/mine/contract/ContractList.vue'),
      meta: {
        title: '我的合同',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/mine/honorwall',
      name: 'mine_honorwall',
      component: () => import('@/module/mine/honorwall/index.vue'),
      meta: {
        title: '荣誉墙',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/mine/honorwalldetail',
      name: 'mine_honorwalldetail',
      component: () => import('@/module/mine/honorwall/honorwalldetail.vue'),
      meta: {
        title: '',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/mine/voucher/detail',
      name: 'voucher_detail',
      component: () => import('@/module/mine/voucher/VoucherDetail.vue'),
      meta: {
        title: '订单详情',
        keepAlive: false,
        logined: true,
        version: '5.0',
      },
    },
    {
      path: '/student/attdence',
      name: 'student_attdence',
      component: () => import('@/module/mine/StudentAttdence'),
      meta: {
        title: '签到通知',
        keepAlive: true,
        logined: true,
      },
    },
    {
      path: '/mine/course/record',
      name: 'mine_course_record',
      component: () => import('@/module/mine/MineCourseHour/MineCourseDetailRecord.vue'),
      meta: {
        title: '购买明细',
        keepAlive: false,
        logined: true,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/Mine.js